import { render } from "./Gestao-Usuario.vue?vue&type=template&id=6c56144c&scoped=true"
import script from "./Gestao-Usuario.vue?vue&type=script&lang=js"
export * from "./Gestao-Usuario.vue?vue&type=script&lang=js"

import "./Gestao-Usuario.vue?vue&type=style&index=0&id=6c56144c&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c56144c"]])

export default __exports__